import React, { Component } from "react";
import {Col, Grid, Row} from "react-flexbox-grid";
import { connect } from "react-redux";
import _cloneDeep from "lodash/cloneDeep";
import _ from "lodash";

// Components
import DocumentsList from "../../components/DocumentsList";

// Actions
import {clearProjectFiles, getFilesByProjectId, setFilter} from "../../redux/files/actions";
import { setProjectId } from "../../redux/checklists/actions";
import {getProject, updateProjectLogo} from '../../redux/projects/actions';
import { getProjectLocations } from '../../redux/locations/actions';
import { categoriesOriginal } from '../../fixtures/categories';
import { getUserProjects } from "../../redux/projects/actions";

// Selectors
import * as checklistSelectors from "../../redux/checklists/selectors";
import * as fileSelectors from "../../redux/files/selectors";
import * as selectors from "../../redux/projects/selectors";
import * as authSelectors from "../../redux/auth/selectors";

// Styles & assets
import "../../styles/GridList.css";
import CategoriesModal from "../projectDetails/CategoriesModal";
import uuid from "uuid";
import {FileStackClient} from "../../services/FileStackService";
import {createPost} from "../../redux/issues/actions";
import {track} from "../../redux/auth/actions";
import FlatButton from "material-ui/FlatButton";
import ActivityIndicator from "react-activity-indicator";
import * as projectSelectors from "../../redux/projects/selectors";

const mapStateToProps = (state) => ({
  userId: authSelectors.getUserId(state),
  projectsList: selectors.projectsList(state),
  projectFiles: fileSelectors.projectFiles(state),

  isFetching: fileSelectors.filesIsFetching(state),
  project: selectors.projectDetails(state),
  filter: fileSelectors.getFilter(state),
  searchEnabled: fileSelectors.fileSearchEnabled(state),
  filesSearchList: fileSelectors.fileSearchList(state),
  projectFetched: selectors.projectIsFetched(state),
  projectIsFetching: selectors.projectIsFetching(state),
  checklistProjectId: checklistSelectors.checklistProjectId(state),

  locations: state.locations.projectsLocation,
  userProfile: authSelectors.getUserProfile(state),


  isSearchFetching: fileSelectors.fileSearchIsFetching(state),
  accessToken: authSelectors.getAccessToken(state),
});

const mapDispatchToProps = {
  getUserProjects,
  getFilesByProjectId,
  setProjectId,
  getProject,
  getProjectLocations,


  clearProjectFiles,
  setFilter,
  createPost,
  track,
  updateProjectLogo,
};

const FILTER = "Plans";

class Plans extends Component {
  state = {
    uploadedFiles: null,
  };

  componentDidMount() {
    const { history, track, getProjectLocations, checklistProjectId } = this.props;
    const {location} = history;
    const {projectId} = this.props.match.params;
    const { userId } = JSON.parse(localStorage.getItem("auth0")) || "";

    // history.push(`plans/`);
    this.props.getUserProjects(userId);

    if (!this.componentHasData()) {
      this.componentUpdateData();
    }

    if (location.state && location.state.action === 'upload') {
      track('Web app: Redirected from email link');

      this._handleUpload();
    }
  }

  componentWillUnmount() {
    this.props.clearProjectFiles();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps === this.props) {
      return;
    }

    if (!this.componentHasData()) {
      this.componentUpdateData(nextProps);
    }

    if (nextProps.checklistProjectId !== this.props.checklistProjectId) {

      if (nextProps.checklistProjectId !== 'PRIVATE') {
        this.props.getFilesByProjectId(nextProps.checklistProjectId);
        this.props.getProject(nextProps.checklistProjectId);
        this.props.getProjectLocations(nextProps.checklistProjectId);

      }
    }


    if (Object.keys(nextProps.projectsList).length !== Object.keys(this.props.projectsList).length) {
      const firstProjectId = Object.values(nextProps.projectsList)[0].id;

      const { setProjectId } = this.props;
      setProjectId(firstProjectId);
    }
  }

  componentHasData(props = this.props) {
    const { project, projectFiles} = this.props;

    if (!project) {
      return false;
    }

    return Object.keys(project).length > 0 && projectFiles !== false;
  }

  componentUpdateData(props = this.props) {
    const { project, projectFiles, checklistProjectId } = props;
    if (checklistProjectId) {
      const projectId = checklistProjectId;

      if (projectId === 'PRIVATE') {
        return;
      }

      if ((props.checklistProjectId !== this.props.checklistProjectId) || !Object.keys(project).length ) {
        this.props.getProject(projectId);
      }

      if (projectFiles !== null && !projectFiles && !Object.keys(projectFiles).length) {
        this.props.getFilesByProjectId(projectId);
      }

      if (projectFiles && Object.keys(projectFiles).length) {
        this.prepareCategories(projectFiles);
        this.prepareLocations(projectFiles);
      }
    }
  }

  prepareLocations(files) {
    const locationsObj = {
      general: {
        location: {
          id: 'General',
          title: 'General',
          symbol: 'GN'
        },
        files: []
      }
    }

    Object.values(files).forEach(file => {
      if (!file.location) {
        return locationsObj.general.files.push(file);
      }

      if (locationsObj[file.location.name]) {
        locationsObj[file.location.name].files.push(file)
      } else {
        locationsObj[file.location.name] = {
          location: {
            id: file.location.id,
            title: file.location.name,
            symbol: file.location.name.slice(0, 2).toUpperCase()
          },
          files: [file]
        }
      }
    })

    this.setState({ filesByLocations: Object.values(locationsObj) })
  }

  _handleGroupsCollect = (groups) => {
    this.setState({
      groups
    })
  };

  prepareCategories(files) {
    let dataForAlbum = {};
    Object.keys(files).map((fileId) => {
      const file = files[fileId];
      if (file.categories) {
        file.categories.map((categoryId) => {

          if (!dataForAlbum[categoryId]) {
            dataForAlbum[categoryId] = {category: categoriesOriginal[categoryId], files: []};
          }

          dataForAlbum[categoryId].files.push(file);
        });
      } else {
        if (!dataForAlbum["noCategory"]) {
          dataForAlbum["noCategory"] = {
            category: {
              id: "noCategory",
              title: 'No categories',
              symbol: "NC"
            },
            files: []
          };
        }

        dataForAlbum["noCategory"].files.push(file);
      }
    });
    dataForAlbum = _.sortBy(dataForAlbum, (item) => {
      return item.files.length;
    }).reverse();

    this.setState({
      album: dataForAlbum
    })
  }

  clearUploaded = () => {
    this.setState({uploadedFiles: null})
  };

  cancelUploadFiles = () => {
    this.clearUploaded();
  }

  uploadFiles = async ({ categories, fileType, location }) => {
    const {createPost, accessToken, userProfile, project, checklistProjectId } = this.props;
    const uploadedFiles = _cloneDeep(this.state.uploadedFiles);
    const now = new Date().getTime();

    const projectId = checklistProjectId

    let messageEntity = {
      title: '',
      createdAt: now,
      updatedTS: now,
      owner: {},
      issueNumber: {},
      id: '',
      images: []
    };

    let files = {};
    uploadedFiles.forEach((file) => {
      const id = uuid.v4();

      files[id] = {
        id: id,
        createdAt: now,
        updatedAt: now,
        categories: categories,
        sharedWith: [],
        owner: '', //get user id
        issues: [], //get message id
        name: file.filename,
        metadata: {
          mimetype: file.mimetype
        },
        filestackId: file.handle,
        type: file.filename && file.filename.match(/\.(jpeg|jpg|gif|png|JPG|PNG|GIF|JPEG)$/) != null ? 'photo' : 'document',
        uri: file.url,
        folder: 'Plans',
        location: location || null,
        projectId: projectId
      }
    });

    await createPost(projectId, messageEntity, files, userProfile, true, project);

    this.clearUploaded();
    this.props.clearProjectFiles();
    this.props.getFilesByProjectId(projectId);
  };

  _handleUpload = () => {
    FileStackClient.picker({
      maxFiles: 20,
      fromSources: [
        "local_file_system",
        "googledrive",
        "dropbox",
        "gmail",
        "box",
        "onedrive",
        "clouddrive"
      ],
      onUploadDone: (res) => {
        const { filesUploaded } = res;
        this.setState({ uploadedFiles: filesUploaded });
      }
    }).open();
  };

  render() {
    const { projectFiles, searchEnabled, filesSearchList, locations, checklistProjectId, project, isFetching } = this.props;
    const { uploadedFiles } = this.state;

    if (!project) {
      return null;
    }

    return (
      <div className="dashboard-page-wrap">
        <Grid className="dashboard-page dashboard-page-small">
          {Object.keys(project).length > 0 &&
          <Row>
            <Col xs={12}>
              <div className="project-details">
                <div className="details">
                  <FlatButton backgroundColor="#6da92e" hoverColor="#83BA2C" labelStyle={{color: '#fff'}} fullWidth label="Upload files" onClick={this._handleUpload} />
                </div>
              </div>
            </Col>
          </Row>
          }
          <Row>

            <CategoriesModal open={!!uploadedFiles} onConfirm={this.uploadFiles} onCancelUpload={this.cancelUploadFiles} locations={locations && checklistProjectId ? locations[checklistProjectId] : false }/>

            {projectFiles !== null && Object.keys(projectFiles).length > 0 &&
              <DocumentsList
                // filesList={projectFiles}
                searchEnabled={searchEnabled}
                filesSearchList={filesSearchList}
                filter={FILTER}
                onGroupsCollect={this._handleGroupsCollect}
              />
            }

            {projectFiles !== null && isFetching && !projectFiles  &&
              <Row center="xs" middle="xs" className="activity-wrapper">
                <Col xs={12}>
                  <ActivityIndicator
                      number={5}
                      diameter={40}
                      duration={100}
                      activeColor="#5BA22F"
                      borderColor="white"
                      borderWidth={5}
                      borderRadius="50%"
                  />
                </Col>
              </Row>
            }
          </Row>
        </Grid>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Plans);
